export default {"src":"__ASTRO_ASSET_IMAGE__BJ52pNva__","width":512,"height":512,"format":"svg"}